namespace e5{
    export interface SvgLoaderOptions extends AjaxLoaderOptions {

    }

    class SvgLoader extends AbstractAjaxLoader<SVGElement, SvgLoaderOptions>{
        protected defaultOptions(): SvgLoaderOptions {
            return {
                decoder: "svg"
            }
        }
    }

    export interface LoaderOptionsMap {
        "svg": SvgLoaderOptions;
    }
    
    export interface LoaderMap {
        "svg": SvgLoader;
    }

    registerLoader("svg", SvgLoader);
}